import { Button, HeaderTextBlock, LayoutContainer } from '@greystar/designsystem';
import { getLinkIcon } from '@greystar/lib';
import React from 'react';

type NoFloorPlansProps = {
  clearFilters: () => void;
  noResultLabel: string;
  filterAdjustLabel: string;
};

export const NoFloorPlans = ({
  clearFilters,
  noResultLabel,
  filterAdjustLabel,
}: NoFloorPlansProps): JSX.Element => {
  return (
    <LayoutContainer
      flexDirection="column"
      gap="lg"
      paddingTop="2xl"
      paddingBottom="2xl"
      alignItems="start"
    >
      <HeaderTextBlock>
        <HeaderTextBlock.Subtitle subtitle={filterAdjustLabel} />
        <HeaderTextBlock.Header header={noResultLabel} />
      </HeaderTextBlock>
      <Button icon={getLinkIcon()} label="Clear filters" variant="primary" onClick={clearFilters} />
    </LayoutContainer>
  );
};
